var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userModule.authError)?_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_vm._v(" "+_vm._s(_vm.userModule.authError)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }